import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateRole as UpdateRoleMutation,
    UpdateRoleVariables as UpdateRoleMutationVariables,
    RoleUpdateInput,
} from 'nutshell-graphql-types';

import ROLE_FRAGMENT from '../fragments/role-fragment.graphql';
import UPDATE_ROLE from '../mutations/update-role.graphql';

export function useUpdateRole(): {
    updateRole: (arg1: RoleUpdateInput) => Promise<any>;
    isUpdating: boolean;
} {
    const [updateRole, {loading}] = useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(
        UPDATE_ROLE
    );

    return {
        updateRole: (input: RoleUpdateInput) =>
            updateRole({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedRole =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.roleUpdate &&
                        mutationResults.data.roleUpdate.role;

                    if (updatedRole) {
                        proxy.writeFragment({
                            id: input.roleId,
                            fragment: ROLE_FRAGMENT,
                            data: updatedRole,
                        });
                    }
                },
            }),
        isUpdating: loading,
    };
}
